import styled from 'styled-components';

const NoData = styled.div`
  width: 100%;
  height: 250px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default NoData;
